module.exports = __webpack_public_path__ + "static/2mynz-logo-b1c56922856cdbf53389ce6aa956930e.png";